module.exports = __webpack_public_path__ + "img/aboutus-min.b287149.png";